import api from "utils/axios";

export async function getPurchaseHistory(page = 1, limit = 10, searchTerm = "", sortBy = "newest") {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      sortBy
    });

    if (searchTerm) {
      params.append('searchTerm', searchTerm);
    }

    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/users/get-orders?${params}`);

    console.log("Calling purchase history", data);
    
    

    if (!data || data.success !== true) {
      throw new Error(data?.message || "Failed to fetch purchase history");
    }

    return {
      purchases: data.data?.orders || [],
      pagination: data.data?.pagination || {
        total: 0,
        page: page,
        limit: limit,
        totalPages: 0
      }
    };
  } catch (error) {
    console.error("getPurchaseHistory error:", error);

    return {
      purchases: [],
      pagination: {
        total: 1,
        page: page,
        limit: limit,
        totalPages: 1
      }
    };
  }
}

export async function getPurchaseDetails(purchaseId) {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/admin/purchase-history/${purchaseId}`);
    if (!data || data.success !== true) {
      throw new Error(data?.message || "Failed to get purchase details");
    }
    return data.data;
  } catch (error) {
    console.error("getPurchaseDetails error:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to get purchase details");
  }
}

export async function getAvailablePlans() {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/admin/subscription-plans`);
    if (!data || data.success !== true) {
      throw new Error(data?.message || "Failed to get subscription plans");
    }
    return data.data?.plans || [];
  } catch (error) {
    console.error("getAvailablePlans error:", error);
    // Return sample plans on error to prevent breaking the UI
    // This will be automatically replaced when real API is implemented
    return [
      { _id: "sample_plan_1", name: "Sample Plan" }
    ];
  }
}
